<h2 mat-dialog-title>View Comments</h2>
<mat-dialog-content>
  <table>
    <thead>
      <td>Date</td>
      <td>Comment</td>
    </thead>
    <tr class="comment-row" *ngFor="let comment of data.comments">
      <td>{{comment.lastUpdatedDate | date:'MM/dd/yyyy hh:mm aa'}}</td>
      <td>{{comment.content}}</td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>